module.exports = "https://secnetweb.ksyun.com/KEC/ksc-node-kvm/assets/iconfont.974d0856db820353a28872e18f4f984c.eot";